export default __webpack_public_path__ + "static/media/Attendance_Filled_Active.ab81be1f.svg";